import { useEffect } from 'react';
import { useParams } from 'react-router';
import { CookieUtil } from '@axiom/ui';
import { isLpUser, isSalesUser } from '@axiom/utils';

import { EnvUtil } from '../../utils/env-util';

export const RedirectToOnboarding = (): null => {
  const { opportunityId, candidateId } = useParams();
  const user = CookieUtil.decodeUserCookie();

  let redirectUrl: string;
  if (isSalesUser(user)) {
    redirectUrl = `${EnvUtil.envoyUrl}/opportunity-detail/${opportunityId}/onboarding`;
  } else if (isLpUser(user)) {
    redirectUrl = `/talent/engagements/${opportunityId}`;
  } else {
    redirectUrl = `/talent/${candidateId}/engagements/${opportunityId}`;
  }

  useEffect(() => {
    window.location.assign(redirectUrl);
  }, [redirectUrl]);

  return null;
};
